import { useState, useEffect } from "react";
import AIheader from '../../RentAI/AIheader';
import Footer from '../../../Component/Footer/Footer';
//import BetaWaitlist from "../../../Component/Beta-Waitlist/BetaWaitlist";
//import JoinPriorityWaitlistBtn from "../../../Component/ViralLoops/JoinPriorityWaitlistBtn";
import './MaximumBooking.css';
import Getstarted from "../../../Component/GetStarted/Getstarted";

const MaximumBooking = () => {

    const [showGetstarted, setShowGetstared] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    
    const menuItems = [
        { id: "max_1", text: "Choose the Right Photos" },
        { id: "max_2", text: "Craft a Compelling Title" },
        { id: "max_3", text: "Highlight Key Features in the Description" },
        { id: "max_4", text: "Set Competitive Pricing" },
        { id: "max_5", text: "Keep Your Calendar Updated" },
        { id: "max_6", text: "Respond Quickly to Inquiries" },
        { id: "max_7", text: "Leverage Reviews and Ratings" },
        { id: "max_8", text: "Maintain Your Vehicle" },
    ];
    useEffect(() => {
        const handleScroll = () => {
            let scrollPosition = window.scrollY - 400; // Adjust offset for better accuracy
            let foundIndex = 0;

            menuItems.forEach((item, index) => {
                const section = document.getElementById(item.id);
                if (section) {
                    const offsetTop = section.offsetTop;
                    if (scrollPosition >= offsetTop) {
                        foundIndex = index;
                    }
                }
            });

            setActiveIndex(foundIndex);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <>
<AIheader/>
<Getstarted
showJoinWaitList={showGetstarted}
onClose={() => setShowGetstared(false)}
onOpen={() => setShowGetstared(true)}
/>
 
{/* START maxBannerMain */}
<section className="maxBannerMain">
    <div className="maxBannerOuter">
        <div className="container">
                <div className='row align-items-center'>
                    <div className='col-lg-6 col-md-6 col-sm-12'>
                        <div className='maxBannerLeft'>
                            {/* <div className="blogHeadingInner">
                                <img width="17px" src="/img/blog/blog_icon_blue.svg" alt="icon"/>
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><a href="/blogs">Blog</a></li>
                                        <img width="" src="/img/arrow-right-nav.svg" alt="rent id"/>
                                        <li className="breadcrumb-item active" aria-current="page">Article 002</li>
                                    </ol>
                                </nav>
                            </div> */}
                            <small>Category name</small>
                            <h2>How to Optimize Your Vehicle Listing for Maximum Bookings</h2>
                            {/* <p>Published: Feb 28, 2025</p>
                            <p><span>Estimated Reading Time: 3 mins</span></p> */}
                            <div className="blogHeadingDetails">
                                <figure>
                                    <img width="42" src="/img/blog/r_logo.svg" alt="icon"/>
                                </figure>
                                <ul>
                                    <li>Editorial Team</li>
                                    <li>Feb 28, 2025</li>
                                    <li>3 min read</li>
                                </ul>
                            </div>
                 
                            <a onClick={()=> setShowGetstared(true)} className="btn btnBlue">Get Started</a>
                        </div>
                    </div>
                </div>
        </div>
        <div className='maxBannerRight'>
            <figure>
                <img  src="/img/blog/maxBanner.webp" alt="blog" />
            </figure>
        </div>
    </div>
</section>
{/* END maxBannerMain */}
 

{/* START maxBannerMain */}
<section className="choosePhotoMain">
    <div className="container">
        <div className='row'>
            <div className='col-lg-3 col-md-3 col-sm-12'>
                <div className='choosePhotoLeft'>
                    <ul>
                        {menuItems.map((item, index) => (
                            <li 
                                key={item.id} 
                                className={index === activeIndex ? "active" : ""}
                                onClick={() => setActiveIndex(index)}
                            >
                                <a href={`#${item.id}`}>{item.text}</a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className='col-lg-9 col-md-9 col-sm-12'>
                <div className='choosePhotoRight'>
                    <div className='choosePhotoTop'>
                        <p>In the world of car rental platforms, standing out is key to ensuring your vehicle gets 
                        noticed and booked by potential renters. Whether you’re a host on Rentii, Turo, 
                        Getaround, or a similar platform, crafting an optimized vehicle listing can make a 
                        world of difference in attracting renters and maximizing bookings. Here are some 
                        practical tips to ensure your vehicle shines among the competition.</p>
                        <a onClick={()=> setShowGetstared(true)} className="btn btnBlue">Get Started</a>
                    </div>


                    <div className='gradientBlogData'>
                            <h3>TL;DR</h3>
                            <p>Rentid's Maximum Booking feature empowers rental operators to set precise limits on booking durations and frequencies. By customizing these parameters, businesses can optimize fleet utilization, prevent overbooking, and enhance operational efficiency. This tool ensures a balanced approach to meeting customer demand while maintaining control over inventory and scheduling.
                            </p>
                        </div>

                    <div className='choosePhotoData' id='max_1'>
                        <h2>1. Choose the Right Photos</h2>
                        <p>First impressions matter, and photos are the first thing renters will see. Ensure your 
                        vehicle photos are high-quality, well-lit, and showcase your car from multiple angles. 
                        Capture shots of the exterior, interior, dashboard, trunk space, and any special 
                        features your car may have (e.g., sunroof, leather seats, infotainment system).</p>

                        <p>Pro tip: Take photos during the "golden hour," the period shortly after sunrise or 
                        before sunset, to make your car look its best. Avoid cluttered or distracting backgrounds—your 
                        vehicle should be the star of the image.</p>
                        <img className="img-fluid max_image_1" src="/img/blog/max_image_1.webp" alt="rent id"/>
                    </div>

                    <div className='choosePhotoData' id='max_2'>
                        <h2>2. Craft a Compelling Title</h2>
                        <p>Your vehicle listing title is one of the first things that grabs attention. 
                        Make it clear, descriptive, and appealing. Include the year, make, model, and 
                        any unique features that set your car apart. For example:</p>
                        <p>"2022 Tesla Model 3 - Autopilot & Premium Interior"</p>
                        <p>Avoid vague titles like "Car for Rent," which don’t offer useful information. 
                        A well-written title gives potential renters a quick understanding of what your car has to offer.</p>
                        {/* <img className="img-fluid" src="/img/blog/craft.png" alt="rent id"/> */}
                    </div>

                    <div className='choosePhotoData' id='max_3'>
                        <h2>3. Highlight Key Features in the Description</h2>
                        <p>The description is your chance to tell renters why they should choose your vehicle. Be sure to include:</p>
                        <ul>
                            <li>Fuel efficiency or eco-friendly aspects (e.g., hybrid or electric vehicles).</li>
                            <li>Comfort features such as heated seats, spacious legroom, or premium sound systems.</li>
                            <li>Special perks like unlimited mileage, car seats for families, or pet-friendly options</li>
                            <li>Use cases like road trips, business meetings, or weekend getaways.</li>
                        </ul>
                        <p>Make the tone friendly but professional, and emphasize anything that makes your car 
                        unique compared to others in your area.</p>
                        <img width="785px" className="img-fluid max_image_3" src="/img/blog/max_image_3.webp" alt="rent id"/>
                    </div>
                    <div className='choosePhotoData' id='max_4'>
                        <h2>4. Set Competitive Pricing</h2>
                        <p>Research similar vehicles in your area to ensure your pricing is competitive. Platforms 
                        often offer dynamic pricing suggestions based on demand, but you can manually adjust 
                        your rates to reflect your car's value and unique features. Don’t forget to highlight 
                        discounts for longer bookings, which often attract renters planning extended trips.</p>
                        <a onClick={()=> setShowGetstared(true)} className="btn btnBlue">Get Started</a>
                    </div>

                    <div className='choosePhotoData' id='max_5'>
                        <h2>5. Keep Your Calendar Updated</h2>
                        <p>An outdated calendar can lead to frustration for renters and missed opportunities for bookings. 
                        Make sure your availability reflects when your car is truly accessible. Many platforms reward 
                        active hosts with better placement in search results, so staying engaged can boost visibility.</p>
                        <img width="924px" className="img-fluid max_image_5" src="/img/blog/max_image_5.webp" alt="rent id"/>
                    </div>

                    <div className='choosePhotoData' id='max_6'>
                        <h2>6. Respond Quickly to Inquiries</h2>
                        <p>Responsiveness is key to building trust with renters. Answer questions promptly, 
                        and be polite and professional in your communication. Quick responses not only 
                        improve your booking chances but also enhance your rating as a host, which directly 
                        impacts your listing's visibility.</p>
                        <img  width="792px" className="img-fluid max_image_6" src="/img/blog/max_image_6.webp" alt="rent id"/>
                    </div>

                    <div className='choosePhotoData' id='max_7'>
                        <h2>7. Leverage Reviews and Ratings</h2>
                        <p>Positive reviews build credibility and encourage more bookings. After each rental, 
                        kindly request renters to leave a review. Highlight any particularly glowing feedback 
                        in your listing description if allowed by the platform.</p>
                        <img className="img-fluid max_image_7" src="/img/blog/max_image_7.webp" alt="rent id"/>
                    </div>

                    <div className='choosePhotoData' id='max_8'>
                        <h2>8. Maintain Your Vehicle</h2>
                        <p>Finally, make sure your car is always in excellent condition. Regular maintenance, 
                        clean interiors, and a full tank of gas (if required) create a better experience 
                        for renters and increase the likelihood of repeat bookings.</p>
                        <p>By optimizing your vehicle listing with these strategies, you not only attract 
                        more renters but also build a strong reputation as a reliable host. In a 
                        competitive market, these small but impactful changes can help you maximize 
                        your earnings and stay ahead of the competition. Happy hosting!</p>
                        <a onClick={()=> setShowGetstared(true)} className="btn btnBlue">Get Started</a>
                    </div>                    
                </div>
            </div>
        </div>
    </div>
 
</section>
{/* END maxBannerMain */}


<Footer/>
        </>
    )
}

export default MaximumBooking;